import {
  REQUEST_DAYLIGHT_SAVINGS, RECEIVE_DAYLIGHT_SAVINGS, RECEIVE_DAYLIGHT_SAVING,
} from '../actions/daylight-savings';

const reducer = (state = {
  items: [],
  loading: false,
  item: {},
}, action) => {
  switch (action.type) {
    case REQUEST_DAYLIGHT_SAVINGS:
      return { ...state, loading: true };
    case RECEIVE_DAYLIGHT_SAVINGS:
      return { ...state, items: action.json.data, loading: false };
    case RECEIVE_DAYLIGHT_SAVING:
      return {
        ...state,
        item: action.json,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
